/*
 * Stores information in localStorage. Compresses that information with lscache.
 */

// Declares window.lscache
import './lscache/lscache.js';

window.dcLocalStorage = {
    setValue: function (key, value, ttl) {
        window.lscache.set(key, value, ttl);
    },

    getValue: function (key) {
        return window.lscache.get(key);
    },
};
